import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';

interface PropertyEditorSectionCardProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Shared section shell for the route-based property editor.
 */
export const PropertyEditorSectionCard: React.FC<
  PropertyEditorSectionCardProps
> = ({ title, description, actions, children }) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
    <div className="mb-4 flex items-start justify-between gap-3">
      <div className="min-w-0 flex-1">
        <Text as="h3" size="h6" weight="semibold" className="text-slate-900">
          {title}
        </Text>
        {description ? (
          <Text size="small" className="mt-1 text-slate-500">
            {description}
          </Text>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </div>
    <div className="flex flex-col gap-4">{children}</div>
  </section>
);
